export default "__VITE_ASSET__DBBfMx$6__"